export default __webpack_public_path__ + "static/testimonialHolder3-71d68e90375da7cfdcab78447bdead5a.png";